import axios from '../../axios/axiosconf';
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { useEffect } from 'react';
import { getHashRouterSearchString } from '../../../utils/hashRouterQuery';

// Instancia axios para hacer solicitud del CSRF Cookie al backend (Ver documentación de Laravel. Solo se hace una vez, cuando el usuario se loggea: https://laravel.com/docs/9.x/sanctum#spa-authentication)
/*const axiosInstanceCSRFCookie = axios.create({
    baseURL: baseUrlCSRFCookie,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
});

// Instancia axios para autenticación
const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
});*/

function ActivateUser() {

    const location = useLocation();
    const search = getHashRouterSearchString(location);
    const queryParams = new URLSearchParams(search);

    const [uid, setUid] = useState(queryParams.get('uid'));
    const [userStatus, setUserStatus] = useState('...');
    let history = useHistory();

    useEffect(() => {
        const s = getHashRouterSearchString(location);
        const p = new URLSearchParams(s);
        const uidParam = p.get('uid');
        setUid(uidParam);
    }, [location]);

    useEffect(() => {

        if (!uid) {
            return;
        }

                axios.get('/activate-user?uid='+uid)
                    .then(response => {
                        console.log(response);
                        if (response.status===200) {

                            setUserStatus(response.data.user_status_message);

                            if (response.data.user_status === '0') {
                                localStorage.setItem('userdata',JSON.stringify(response.data));
                                
                                history.push('/setup-cuenta');
                            }
                            else if (response.data.user_status === '1') {
                                history.push('/');
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error.response);
                    });

    },[uid, history]);
    
    //return null;

    return <div>{userStatus}</div>;
}

export default ActivateUser;